import {z} from 'zod';
import {ELEMENT} from '../../elements/base/ElementTypes';
import {MAX_LIKERT_QUESTION_LENGTH, MAX_LIKERT_SCALE_LENGTH, MIN_LIKERT_QUESTION_LENGTH, MIN_LIKERT_SCALE_LENGTH} from './constant';
import {questionBaseValidator} from './questionBase';

export const questionValidator = z.object({
    text: z
        .string()
        .min(MIN_LIKERT_QUESTION_LENGTH, `text;min;${MIN_LIKERT_QUESTION_LENGTH}`)
        .max(MAX_LIKERT_QUESTION_LENGTH, `text;max;${MAX_LIKERT_QUESTION_LENGTH}`),
});

export const scaleValidator = z.object({
    text: z
        .string()
        .min(MIN_LIKERT_SCALE_LENGTH, `text;min;${MIN_LIKERT_SCALE_LENGTH}`)
        .max(MAX_LIKERT_SCALE_LENGTH, `text;max;${MAX_LIKERT_SCALE_LENGTH}`),
});

export const likertScaleQuestionValidator = questionBaseValidator.extend({
    type: z.literal(ELEMENT.LIKERT_SCALE),
    questions: z.array(questionValidator).min(1, 'leftElement;min;1'),
    scale: z.array(scaleValidator).min(2, 'rightElement;min;2'),
});
